module.exports = __webpack_public_path__ + "static/img/jiagedi.2a7772a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/jiagedi.png
// module id = 7Dlg
// module chunks = 0